import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=58a78f16&"
import script from "./SankeyChart.vue?vue&type=script&lang=js&"
export * from "./SankeyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports